import React from 'react';
import TabProvider from 'context/restaurant/TabContext';
import CartProvider from 'context/restaurant/CartContext';
import WaiterFlow from './WaiterFlow';

export default function WaiterPage() {
    return (
        <TabProvider>
            <CartProvider>
                <WaiterFlow />
            </CartProvider>
        </TabProvider>
    );
}
